import { Dispatch, SetStateAction } from "react"
import { useTranslation } from "react-i18next"

import { SortBuilder } from "~/components/SortBuilder"
import { FindProductsTraceabilityRequestSortsDto } from "~/gen/api"

interface Props {
  sorts: FindProductsTraceabilityRequestSortsDto
  setSorts: Dispatch<SetStateAction<FindProductsTraceabilityRequestSortsDto>>
}

export const ProductTraceabilitySorts = ({ sorts, setSorts }: Props) => {
  const { t } = useTranslation("products")

  return (
    <SortBuilder<FindProductsTraceabilityRequestSortsDto>
      options={[
        { label: t("sorts.name"), value: "name" },
        { label: t("sorts.brandReference"), value: "brandReference" },
        { label: t("sorts.purchaseOrder"), value: "purchaseOrder" },
        { label: t("sorts.brand"), value: "brand" },
        { label: t("sorts.color"), value: "color" },
        { label: t("sorts.brandType"), value: "brandType" },
        { label: t("sorts.collection"), value: "collection" },
        { label: t("sorts.traceabilityStatus"), value: "traceabilityStatus" },
        {
          label: t("sorts.traceabilityLaunchDate"),
          value: "traceabilityLaunchDate",
        },
      ]}
      sorts={sorts}
      setSorts={setSorts}
    />
  )
}
